export function defaultHandler(err, vm, info) {
  const message = 'ErrorHandler: Unknown Error';
  console.error(message, err, vm, info);
  vm.$Sentry?.captureErrorMessage(message, err);

  // vm.$Message.error({ content: 'Unknown Error' });
  return false;
}
